<span class="last-usage" [ngClass]="class">{{usage}}</span>